import { render, staticRenderFns } from "./ViewGamesByGenre.vue?vue&type=template&id=c2a60360&"
import script from "./ViewGamesByGenre.vue?vue&type=script&lang=js&"
export * from "./ViewGamesByGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports